// tokenRefreshWebSocket.js
import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";
import axios from "axios";
import createEnvironment from "../global";
const ENV_VAR = createEnvironment();
const BASE_URL = ENV_VAR.BASE_URL;
let stompClient = null;
let sessionId = null;
const refreshToken = async () => {
    console.log("🔗 call refresh token");
    const accessToken = localStorage.getItem("access_token_web");
    if (!accessToken || !sessionId) {
        console.warn("⚠️ Missing token or sessionId for refresh");
        return;
    }
    try {
        const response = await axios.post(
            `${BASE_URL}/auth/login/refreshSessionToken?sessionId=${sessionId}`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
        const newToken = response.data?.access_token;
        if (newToken) {
            localStorage.setItem("TDFToken", newToken);
            localStorage.setItem("access_token_web", newToken);
        }
    } catch (error) {
        console.error("❌ Error refreshing token:", error);
    }
};

export const startTokenRefreshWebSocket = (token, username) => {
    if (!token || !username) {
        return;
    }

    if (stompClient && stompClient.connected) {
        return;
    }

    stompClient = new Client({
        webSocketFactory: () =>
            new SockJS(`${BASE_URL}/auth/ws?user=${encodeURIComponent(username)}`),
        connectHeaders: {},
        reconnectDelay: 5000,
        onConnect: () => {
            console.log("conneted to ws")
            stompClient.subscribe("/user/queue/refresh", (message) => {
                const data = JSON.parse(message.body);
                sessionId = data.sessionId;
                console.log(sessionId)
                refreshToken();
            });
        },
        onStompError: (frame) => {
        },
        onWebSocketError: (err) => {
        },
    });

    stompClient.activate();
};

export const stopTokenRefreshWebSocket = () => {
    if (stompClient) {
        stompClient.deactivate();
        stompClient = null;
        console.log("🛑 WebSocket disconnected");
    }
};